import FormNumberInput from './FormNumberInput';

export default FormNumberInput;
